<template>
  <Card :title="name">
    <div class="zybz" v-for="(n, i) in mainDisease" :key="i">
      <Field
        style="flex: 1"
        :readonly="readonly"
        v-model="n.name"
        placeholder="请输入病种"
      />
      <Field
        :readonly="readonly"
        v-model="n.number"
        type="digit"
        placeholder="请输入数量"
        style="flex: 1.2"
      >
        <template #button>例</template>
      </Field>
      <VanBtn
        v-if="!readonly"
        round
        style="width: 60px"
        @click="delZYBZ(i)"
        :disabled="mainDisease.length === 1"
        type="danger"
        color="#EA514B"
        size="small"
        >删除</VanBtn
      >
    </div>
    <div class="action" v-if="!readonly">
      <VanBtn round type="primary" size="small" @click="addZYBZ()">添加</VanBtn>
    </div>
  </Card>
</template>
<script>
import { Field, Button as VanBtn } from "vant";
import Card from "@/components/trainingManual/card/Card.vue";
export default {
  name: "MainDisease",
  props: {
    title: String,
    readonly: Boolean
  },
  data: function() {
    return {
      name: "二、护理的主要病种记录",
      mainDisease: [{ name: "", number: null, type: 1, countWay: 2 }]
    };
  },
  methods: {
    addZYBZ() {
      this.mainDisease.push({ name: "", number: null, type: 1, countWay: 2 });
    },
    delZYBZ(index) {
      if (this.mainDisease.length === 1) {
        return;
      }
      this.mainDisease.splice(index, 1);
    }
  },
  components: { Card, Field, VanBtn }
};
</script>
<style lang="scss" scoped>
.zybz {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.action {
  display: flex;
  justify-content: space-around;
  margin-top: 20px;
  button {
    width: 36%;
  }
}
</style>
